import { useQuery } from '@tanstack/react-query';
import { lessonApi } from '@/lib/api-client';
import { queryKeys } from '@/config/query-client';

/**
 * What the lesson's read sources cover, for the build view's "What's coming"
 * panel while the outline is being made (`GET /lessons/{id}/build-preview`).
 *
 * Enabled once source ingestion has completed - before that there is nothing
 * read to preview. Fetched once: no polling, and no refetch on focus, since
 * the preview only fills the wait until the draft mind map replaces it.
 */
export function useBuildPreview(
  lessonId: string | undefined,
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: queryKeys.lessons.buildPreview(lessonId ?? ''),
    queryFn: () => lessonApi.getBuildPreview(lessonId as string),
    enabled: (options.enabled ?? true) && !!lessonId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
